import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../../components/ui';

const BAR_SEMANTICS = ['info', 'primary', 'success', 'warning', 'danger', 'secondary'];

/**
 * Distribution list with themed progress bars (ticketing-style).
 */
const ReportBreakdownCard = ({
  title,
  description,
  items = [],
  total,
  theme,
  dash,
  cn,
  cardClassName,
  emptyMessage = 'No data.',
}) => {
  const denom = total > 0 ? total : items.reduce((s, i) => s + (i.count || 0), 0) || 1;

  return (
    <Card className={cardClassName}>
      <CardHeader>
        <CardTitle className="text-lg">{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <div className={cn('text-center py-8', theme.text.muted)}>
            <p className="text-sm">{emptyMessage}</p>
          </div>
        ) : (
          <ul className="space-y-4 m-0 p-0 list-none">
            {items.map((item, index) => {
              const count = item.count || 0;
              const pct = (count / denom) * 100;
              const semantic = item.semantic || BAR_SEMANTICS[index % BAR_SEMANTICS.length];
              return (
                <li key={item.label}>
                  <div className="flex justify-between items-baseline gap-3 mb-1.5 text-sm">
                    <span
                      className={cn('font-medium truncate min-w-0', theme.text.secondary)}
                      title={item.label}
                    >
                      {item.label}
                    </span>
                    <span className="tabular-nums shrink-0 text-right">
                      <span className={cn('font-semibold', theme.text.primary)}>{count}</span>
                      <span className={cn('text-xs ml-1.5', theme.text.muted)}>{pct.toFixed(1)}%</span>
                    </span>
                  </div>
                  <div className={cn(dash.progressTrack, 'h-2.5 overflow-hidden')}>
                    <div
                      className={cn(dash.fill(semantic), 'h-2.5 rounded-full transition-all duration-500')}
                      style={{ width: `${Math.max(pct, count > 0 ? 2 : 0)}%` }}
                    />
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
};

export default ReportBreakdownCard;
